import { render } from "./AboutHero.vue?vue&type=template&id=d020625c&scoped=true"
import script from "./AboutHero.vue?vue&type=script&lang=js"
export * from "./AboutHero.vue?vue&type=script&lang=js"

import "./AboutHero.vue?vue&type=style&index=0&id=d020625c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d020625c"]])

export default __exports__